<template>
    <div class="card">
        <div class="card-header">
            联系人信息
        </div>
        <div class="card-body">
            <div v-if="personId">
                <person-basic-info-view class="mb-3" :person-id="personId" :show-detail-info="false"></person-basic-info-view>
                <person-contact-info-view class="mb-3" :person-id="personId"></person-contact-info-view>
                <person-work-info-view :person-id="personId"></person-work-info-view>
            </div>
            <div v-else>
                <div class="alert alert-warning mb-0">没有联系人信息</div>
            </div>
        </div>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
import PersonBasicInfoView from "@/views/organ/OrganPersonBasicInfoView";
import PersonContactInfoView from "@/views/organ/OrganPersonContactInfoView";
import PersonWorkInfoView from "@/views/organ/OrganPersonWorkInfoView";

export default {
    name: "CollegeOrganContactPersonView",
    components: {PersonWorkInfoView, PersonContactInfoView, PersonBasicInfoView},
    props: {
        ownerId: {type: String, required: true},
        personType: {type: Number, required: true},
    },
    data: function () {
        return {
            personId: null,
        };
    },
    mounted() {
        this.getPersonData();
    },
    methods: {
        getPersonData() {
            userApi.person.basic.getOrganDataWithPaging({
                ownerId: this.ownerId, personType: this.personType, rowCountPerPage: -1
            }).then(res => {
                if (res.data.data.length === 0) {
                    this.personId = null;
                }
                else {
                    this.personId = res.data.data[0].personId;
                }
            });
        },
    }
}
</script>

<style scoped>

</style>